<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="emArchToolResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      with-custom-row-actions-first-column
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      enable-over-check
                                      ref="emTable" :importEnabled="true" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <stock-task-print
                                            :selected-items="selectedRows"
                                            :tag-business-code="1"
                                            :tag-material-code="1"
                                            :print-label-text=printLabelText
                                            :request-param="dynamicRequestParam"
                                            @refresh="handleSuccess"
                                            @taskCreatedSuccess = "handleGoto"
                                    />
                                </template>
                                <template #customRowActionsFirstColumn="{row}">
                                    <div class="d-flex justify-content-center align-items-center">
                                        <em-button
                                                type="edit" custom-icon="fa fa-fw fa-lg fa-link"
                                                custom-label="epc code管理"
                                                style="width: max-content"
                                                @success="handleSuccess"
                                                v-bind:class="'btn btn-outline-primary btn-sm'"
                                                @click="operateEpcCode(row)">
                                        </em-button></div>
                                </template>
                            </em-table>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <epc-bind-dialog
                :visible.sync="showEpcDialog"
                :bind-id="currentBindId"
                @success="handleSuccess"
                :tag-business-code=1
        />
    </div>
</template>
<script>
// Author SWL
// Date 2022-03-29 16:43:52

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import EpcBindDialog from "@/components/em/EmEpc/EmBindEpcComponent.vue";
import browserPrint from "@/mixin/common/browserPrinter-mixin";
import StockTaskPrint from "@/components/em/EmEpc/StocktakeTaskAndPrint.vue";
import {trim} from "lodash";

export default {
    name: "emArchToolListView",
    components: {StockTaskPrint, EpcBindDialog},
    mixins: [emCommonListMixin, emCustomVuexMixin, emCommonGotoMixin, browserPrint],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            showEpcDialog: false,
            currentBindId: 0,
            loading: false,
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        selectedRows() {
            return this.selectedItems;
        },
        dynamicRequestParam() {
            let requestParam = []
            for (let i = 0; i < this.selectedItems.length; i++) {
                requestParam.push({
                    "arcTypeLevelOne": trim(this.selectedItems[i].typeName),
                    "arcTypeLevelTwo": trim(this.selectedItems[i].detailType),
                    "arcName": trim(this.selectedItems[i].name),
                    "arcCode": trim(this.selectedItems[i].identificationCode),
                    "arcSize": trim(this.selectedItems[i].modelNumber),
                    "arcUnit": trim(this.selectedItems[i].unit),
                    "expectedBin": trim(this.selectedItems[i].binLocation),
                    "expectedQuantity": trim(this.selectedItems[i].quantity),
                    "epcCode": trim(this.selectedItems[i].epcCode)
                })
            }
            return requestParam;
        }
    },
    methods: {
        operateEpcCode(row) {
            this.currentBindId = row.id;
            this.showEpcDialog = true;
        },
        printLabelText (row) {
            return row.identificationCode;
        },
        handleSuccess() {
            this.$refs.emListFilter.doQuery();
        },
        handleGoto(response) {
            this.$_emGotoMixin_gotoHolderList("emStocktakingTask"
                    , {taskCodeFilter: response}
                    , {taskCode: response}
                    , false, {})
        },
    }
};
</script>
